const ROUTINE_TYPES = {
  SUPER_SET: 'super_set',
  CIRCUIT: 'circuit',
};

export default ROUTINE_TYPES;
